<template>
  <Transition>
    <div class="home-loading" v-show="showLoading">
      <div id="loading">
        <div class="loader"></div>
      </div>
    </div>
  </Transition>
</template>
<script>
export default {
  name: "LoadingIcon",
  props: {
    showLoading: Boolean
  }
};
</script>

<style scoped>
.home-loading {
  width: 100%;
  z-index: 1000;
  margin: auto;
  height: 100%;
  text-align: left;
  position: absolute;
  transition: opacity 0.5s ease;
}
#loading {
  width: 100%;
  height: 100%;
  background: rgb(255 255 255 / 50%);
  display: flex;
}
.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #0881217d;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/Loading.vue